webpackJsonp([9],{

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
var mc = __webpack_require__(0);
mc.runVue(['Slider', 'Navigation', 'slickSlider']);
mc.runComponents(['rating']);
mc.runFooter();

/***/ })

},[96]);


// WEBPACK FOOTER //
// bundles/product.bundle.js